import { Palette } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useSidebarThemeStore } from '../stores/sidebarThemeStore'

/**
 * SidebarThemeToggle (BLOK 4) — wisselt de sidebar-skin tussen 'orion-blauw' en 'licht'. Volgt de vorm
 * van de bestaande ThemeToggle (simple): een icoon-knop in de sidebar-kop, naast ThemeToggle +
 * LanguageSwitcher. Staat los van de app-brede dark/light-keuze.
 */
export default function SidebarThemeToggle() {
  const { t } = useTranslation()
  const actiefThema = useSidebarThemeStore((s) => s.actiefThema)
  const setThema = useSidebarThemeStore((s) => s.setThema)
  const isBlauw = actiefThema === 'orion-blauw'
  const naam = isBlauw
    ? t('sidebar.thema.orionBlauw', { defaultValue: 'Orion-blauw' })
    : t('sidebar.thema.licht', { defaultValue: 'Licht' })

  return (
    <button
      onClick={() => setThema(isBlauw ? 'licht' : 'orion-blauw')}
      className="p-2 rounded-lg hover:bg-blue-500/10 transition-colors"
      title={t('sidebar.thema.wissel', { defaultValue: 'Sidebar-thema wisselen' }) + ` — ${naam}`}
      aria-label={t('sidebar.thema.wissel', { defaultValue: 'Sidebar-thema wisselen' }) + ` — ${naam}`}
    >
      {/* Erft de kop-kleur (sb.kopIcon) zodat de drie iconen samenhangend en op beide skins leesbaar zijn. */}
      <Palette className="w-5 h-5 text-current" />
    </button>
  )
}
